module.exports = __webpack_public_path__ + "static/media/mountain.e01f0e3a.svg";